import React from 'react';
import { DefaultSeo as DefaultSeoBase } from 'next-seo';
import SEO from '../../../next-seo.config';

export default function DefaultSeo() {
  return <DefaultSeoBase {...SEO} />;
}
